import { $Q } from './query-selector';

/**
A function that adds a script tag to the document body.
@param {string} script - The source URL of the script.
@returns {void}
*/
export const addTagScript = (script, id = null) => {
  const scriptById = $Q(`#${id}`);
  if (window[id] || scriptById) {
    return new Promise((resolve) => {
      resolve(true);
    });
  }

  return new Promise((resolve, reject) => {
    const scriptTag = document.createElement('script');
    scriptTag.src = script;
    scriptTag.defer = 'defer';

    if (id) scriptTag.setAttribute('id', id);

    scriptTag.onload = () => {
      window[id] = true;
      resolve(true);
    };

    scriptTag.onerror = () => {
      reject(new Error(`Failed to load script ${src}`));
    };

    const theme = $Q('#MainContent');
    theme.insertAdjacentElement('beforebegin', scriptTag);
  });
};
